// @ts-nocheck
import React, { useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import dayjs from "dayjs";

import { GatsbyImage } from "gatsby-plugin-image";
import { Button } from "react-components";

import RichText from "../../components/contentful/richText";
import AnchorLink from "../../components/anchorLink";

import styles from "./styles.css";

function readingTimeFromWords(words) {
    let result = 1;

    const textLength = words.split(" ").length; // Split by words
    if (textLength > 0) {
        result = Math.ceil(textLength / 200);
    }

    return `${result} min${result > 1 ? "s" : ""} read`;
}

function formatDate(date) {
    return dayjs(date).format("DD MMMM YYYY");
}

function CardHighlighted({ item, styles }) {
    return (
        <AnchorLink
            key={item.id}
            className={cn(styles.card, styles[`card--${item.type}`])}
            href={`/blog/${item.slug}/`}
        >
            {item.preview && (
                <div className={styles.imageContainer}>
                    <GatsbyImage alt={""} className={styles.image} image={item.preview.gatsbyImageData} />
                    <div className={styles.gradient} />
                </div>
            )}
            <div className={styles.summary}>
                <h2 className={styles.cardTitle}>{item.title}</h2>
                <div className={styles.excerpt}>
                    <p className={styles.info}>
                        {readingTimeFromWords(item.body.raw)} | {formatDate(item.publishDate)}
                    </p>
                </div>
            </div>
        </AnchorLink>
    );
}

CardHighlighted.propTypes = {
    item: PropTypes.object,
    styles: PropTypes.object,
};

function Card({ item, styles }) {
    return (
        <div className={styles.card}>
            {item.preview && (
                <AnchorLink href={`/blog/${item.slug}/`}>
                    <div className={styles.imageContainer}>
                        <GatsbyImage alt={""} className={styles.image} image={item.preview.gatsbyImageData} />
                    </div>
                </AnchorLink>
            )}
            <div className={styles.summary}>
                <p className={styles.info}>
                    {readingTimeFromWords(item.body.raw)} | {formatDate(item.publishDate)}
                </p>
                <AnchorLink href={`/blog/${item.slug}/`}>
                    <h4 className={styles.cardTitle}>{item.title}</h4>
                </AnchorLink>
                <AnchorLink href={`/blog/${item.slug}/`}>
                    <div className={styles.excerpt}>
                        <RichText content={item.excerpt} plain maxlength={125} />
                    </div>
                </AnchorLink>
            </div>
        </div>
    );
}

Card.propTypes = {
    item: PropTypes.object,
    styles: PropTypes.object,
};

export default function BlogList({ title, items, topItems = [] }) {
    const topIds = [];

    const itemsFiltered = [
        ...(topItems
            ? topItems.map((item) => {
                  item.type = "highlight-big";
                  topIds.push(item.id);
                  return item;
              })
            : []),
        ...items
            .map((item) => {
                item.type = "card";
                return item;
            })
            .filter((item) => {
                return topIds.indexOf(item.id) === -1;
            }),
    ];

    const initialCount = 12;
    const loadCount = 6;
    let offset = 0;

    itemsFiltered.forEach((item) => {
        if (item.type === "highlight-big") {
            offset++;
        }
        return;
    });

    const itemsCount = itemsFiltered.length;

    const currentIndex = initialCount - offset;

    const [loadedItems, setLoadedItems] = useState(itemsFiltered.splice(0, currentIndex));
    const [page, setPage] = useState(0);

    function loadMore() {
        const index = page * loadCount;
        setLoadedItems([...loadedItems, ...itemsFiltered.splice(index, loadCount)]);
        setPage(page + 1);
    }

    return (
        <div className={styles.BlogList}>
            {title && <h3 className={styles.title}>{title}</h3>}
            <div className={styles.container}>
                {loadedItems.map((item) => {
                    if (item.type === "highlight-big") {
                        return <CardHighlighted key={item.id} item={item} styles={styles} />;
                    } else {
                        return <Card key={item.id} item={item} styles={styles} />;
                    }
                })}
            </div>
            {loadedItems.length < itemsCount && (
                <Button modifiers={["large"]} className={styles["loadButton"]} onClick={() => loadMore()}>
                    Load more
                </Button>
            )}
        </div>
    );
}

BlogList.propTypes = {
    items: PropTypes.array,
    title: PropTypes.string,
    topItems: PropTypes.array,
};
